import { render } from "./DragTable.vue?vue&type=template&id=22b2e8d2"
import script from "./DragTable.vue?vue&type=script&lang=js"
export * from "./DragTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__